import { render, staticRenderFns } from "./tabGeneralUICustom.vue?vue&type=template&id=65ed0702&scoped=true&"
import script from "./tabGeneralUICustom.vue?vue&type=script&lang=js&"
export * from "./tabGeneralUICustom.vue?vue&type=script&lang=js&"
import style0 from "./tabGeneralUICustom.vue?vue&type=style&index=0&id=65ed0702&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65ed0702",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('65ed0702')) {
      api.createRecord('65ed0702', component.options)
    } else {
      api.reload('65ed0702', component.options)
    }
    module.hot.accept("./tabGeneralUICustom.vue?vue&type=template&id=65ed0702&scoped=true&", function () {
      api.rerender('65ed0702', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/AirExport/components/AeBooking/tabs/tabGeneralUICustom.vue"
export default component.exports